// CYBORG-1198: a digest of a set of task ids, so a board delta can skip the full id
// list when the client already holds exactly the visible set. MUST stay byte-identical
// between packages/ui/src/lib/core/task-ids-digest.ts and
// packages/server/src/server/cyborg/task-ids-digest.ts (both pin the same vectors).
export function taskIdsDigest(ids: readonly string[]): string {
  const sorted = [...ids].sort();
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  const mix = (c: number): void => {
    h1 = Math.imul(h1 ^ c, 2654435761);
    h2 = Math.imul(h2 ^ c, 1597334677);
  };
  for (const id of sorted) {
    for (let i = 0; i < id.length; i++) mix(id.charCodeAt(i));
    mix(10);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  const hex = (n: number): string => (n >>> 0).toString(16).padStart(8, "0");
  return `${sorted.length}:${hex(h2)}${hex(h1)}`;
}
